import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'pioneer-add-event-button-bar',
  templateUrl: './add-event-button-bar.component.html'
})
export class AddEventButtonBarComponent {

  @Input()
  eventForm: FormGroup;

  @Output()
  cancel = new EventEmitter();

  @Output()
  save = new EventEmitter();

  constructor() { }

  cancelClick() {
    this.cancel.emit();
  }

  saveClick() {
    this.save.emit();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/add-event-button-bar/add-event-button-bar.component.ts